<template>
  <div class="animated fadeI">
    <el-form
      ref="myOnLeaveForm"
      label-position="top"
      @submit.native.prevent
      label-width="150px"
    >
      <el-card class="box-card-account-on-leave mb-3">
        <div slot="header" class="el-card-header">
          <span class="title-card-header">Quản lý ngày nghỉ</span>
        </div>
        <div class="">
          <b-row>
            <b-col class="mb-3" md="12">
              <p>Năm nay</p>
            </b-col>
            <b-col md="12">
              <el-form
                ref="myForm"
                :model="mData.dataForm"
                :rules="mData.validForm"
                label-position="left"
                label-width="260px"
              >
                <b-row>
                  <b-col md="6" class="pl-5 mb-1">
                    <p>
                      Số ngày nghỉ phép có trong năm:
                      {{
                        mData.dataForm.allow_dayoff_number ? Math.round(mData.dataForm.allow_dayoff_number * 100) / 100 : "0"
                      }}
                    </p>
                  </b-col>
                  <b-col md="6" class="pl-5 mb-2">
                    <p>
                      Số ngày nghỉ còn lại:
                      {{
                        Math.round(mData.dataForm.remaining_leave_of_the_year * 100) / 100
                      }}
                    </p>

                  </b-col>
                  <b-col md="6" class="pl-5">
                    <p>
                      Số ngày nghỉ không phép trong năm:
                      {{
                        mData.dataForm.unallow_dayoff_number ? Math.round(mData.dataForm.unallow_dayoff_number * 100) / 100 : "0"
                      }}
                    </p>
                  </b-col>
                  <b-col md="6" class="pl-5 mb-2">
                    <p>
                      Số ngày nghỉ không phép còn lại:
                      {{
                        Math.round(mData.dataForm.unexcused_days_remaining_of_the_year * 100) / 100
                      }}
                    </p>
                  </b-col>
                </b-row>
              </el-form>
            </b-col>
            <b-col md="12" class="mt-2">
              <p class="mb-2">Lịch sử</p>
              <el-table
                :data="mData.ListDayoffs"
                style="width: 100%"
                border
              >
                <el-table-column
                  prop="Year"
                  label="Năm"
                  width="100"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="Allow_dayoff_number"
                  label="Số ngày nghỉ phép trong năm"
                  min-width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.Allow_dayoff_number ? Math.round(scope.row.Allow_dayoff_number * 100) / 100 : 0
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Allow_dayoff_remain_number"
                  label="Số ngày nghỉ phép còn lại"
                  min-width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.Allow_dayoff_remain_number ? Math.round(scope.row.Allow_dayoff_remain_number * 100) / 100 : 0
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Unallow_dayoff_number"
                  label="Số ngày nghỉ không phép trong năm"
                  min-width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.Unallow_dayoff_number ? Math.round(scope.row.Unallow_dayoff_number * 100) / 100 : 0
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Unallow_dayoff_remain_number"
                  label="Số ngày nghỉ không phép còn lại trong năm"
                  min-width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.Unallow_dayoff_remain_number ? Math.round(scope.row.Unallow_dayoff_remain_number * 100) / 100 : 0
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="Thao tác" align="center">
                  <template slot-scope="scope">
                    <el-button
                    plain
                    round
                    size="mini"
                    @click="fn_detailDayOffReq(scope.row.Year)"
                    v-b-popover.hover.left="aLang.c_view"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </b-col>
          </b-row>
        </div>
      </el-card>
    </el-form>
    <el-dialog
      title="Danh sách yêu cầu xin nghỉ"
      width="70%"
      top="5vh"
      :visible.sync="mData.dialogHistoryDayOffReq"
      :close-on-click-modal="false"
    >
      <el-table
        :data="mData.historyDayOffReq"
        border
        @sort-change="fn_tableSortChange"
        style="width: 100%"
        :default-sort="{
          prop: mData.tableRules.defaultSort[0],
          order: mData.tableRules.defaultSort[1],
        }"
      >
        <el-table-column prop="" label="STT" width="50">
          <template slot-scope="scope">
            <div class="text-center">
              {{ mData.tableRules.offset + scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ShiftName"
          label="Tên ca"
          min-width="250"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              trigger="hover"
              :open-delay="800"
              :content="scope.row.ShiftName"
            >
              <span class="content" slot="reference">{{
                scope.row.ShiftName
              }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="Loại"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              trigger="hover"
              :open-delay="800"
              :content="scope.row.Type == 'LEAVE_WITH_PAY' ? 'Nghỉ có lương' : 'Nghỉ không lương'"
            >
              <span class="content" slot="reference">{{
                scope.row.Type == "LEAVE_WITH_PAY" ? "Nghỉ có lương" : "Nghỉ không lương"
              }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="DayoffTime"
          label="Ngày"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            {{ fn_formatDate(scope.row.DayoffTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="OffTime"
          label="Thời gian nghỉ"
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="Title"
          label="Ghi chú"
          min-width="250"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              trigger="hover"
              :open-delay="800"
              :content="scope.row.Title"
            >
              <span class="content" slot="reference">{{
                scope.row.Title
              }}</span>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right mt-2" v-if="mData.tableRules.allowPaging">
        <el-pagination
          @size-change="fn_tableSizeChange"
          @current-change="fn_tableCurentChange"
          @prev-click="fn_tablePrevClick"
          @next-click="fn_tableNextClick"
          :page-sizes="mData.tableRules.lengthMenu"
          :page-size="mData.tableRules.limit"
          :current-page="Number(mData.tableRules.page)"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="mData.tableRules.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import LanguageService from "@/service/LanguageService";
import ValidService from '../../service/ValidService';
import MethodService from "../../service/MethodService";
import EventBus from '../../service/EventBus';
import EmployeeModel from '../../views/admin/Employees/EmployeeModel';
import EmployeeDayOffApi from '../../moduleApi/EmployeeDayOffApi';
import EmployeeRequestApi from '../../moduleApi/EmployeeRequestApi';

export default {

  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        dialogHistoryDayOffReq: false,
        employeeId: "",
        moduleName: "EmployeeManager", //requied
        tableRules: MethodService.copyObject(EmployeeModel.tableRules),
        ListDayoffs: [],
        dataForm: {
          id: undefined,
          allow_dayoff_number: undefined,
          unallow_dayoff_number: undefined,
          remaining_leave_of_the_year: 0,
          unexcused_days_remaining_of_the_year: 0
        },
        validForm: {
          allow_dayoff_number: [ValidService.required, ValidService.checkNumberInteger],
          unallow_dayoff_number: [ValidService.required, ValidService.checkNumberInteger],
        },
        dataDefault: {
          listTrangThai: [],
        },
        statusHaveDayOff: false,
        historyDayOffReq: [],
      },
      year: '',
    };
  },
  methods: {
    async fn_detailDayOffReq(year) {
      this.mData.dialogHistoryDayOffReq = true;
      this.year = year;
      let dataFilter = {
        year: year,
        employee_id : this.$router.currentRoute.params.id
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.skip = this.mData.tableRules.offset;
      }
      const dayOffRequestApiRes = await EmployeeRequestApi.GetListEmloyeeRequestDayoff(dataFilter);
      this.mData.tableRules.total = dayOffRequestApiRes.result.total;
      if (dayOffRequestApiRes.result) {
        this.mData.historyDayOffReq = dayOffRequestApiRes.result.listRequestDayOffs;
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
      } else {
        this.mData.tableRules.data = [];
      }

      if (
        this.mData.tableRules.offset == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1;
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
        await this.fn_detailDayOffReq(year);
      }
    },

    async fn_initData(){
      let dataFilter = {
        employeeId : this.$router.currentRoute.params.id
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.skip = this.mData.tableRules.offset;
      }
      let listDayoffsRes = await EmployeeDayOffApi.getListDayoffs(dataFilter);
      let dayoffCurrentYearRes = await EmployeeDayOffApi.getDayoffCurrentYear({employeeId:this.$router.currentRoute.params.id});
      if(listDayoffsRes.result){
        this.mData.ListDayoffs = listDayoffsRes.result;
      }
      if(dayoffCurrentYearRes.result){
        this.mData.dataForm.id = dayoffCurrentYearRes.result.Id;
        this.mData.dataForm.allow_dayoff_number = dayoffCurrentYearRes.result.Allow_dayoff_number;
        this.mData.dataForm.unallow_dayoff_number = dayoffCurrentYearRes.result.Unallow_dayoff_number;
        this.mData.dataForm.remaining_leave_of_the_year = dayoffCurrentYearRes.result.Allow_dayoff_remain_number;
        this.mData.dataForm.unexcused_days_remaining_of_the_year = dayoffCurrentYearRes.result.Unallow_dayoff_remain_number;
        this.mData.statusHaveDayOff = true;
      }else{
        this.mData.dataForm = {
          allow_dayoff_number: undefined,
          unallow_dayoff_number: undefined,
          remaining_leave_of_the_year: 0,
          unexcused_days_remaining_of_the_year: 0
        };
        this.mData.statusHaveDayOff = false;
      }
    },
    async fn_getDataById(id){

    },
    async fn_submit(type){
      // let currentYear = new Date().getFullYear();
      // let data = this.mData.dataForm;
      // delete data.remaining_leave_of_the_year;
      // delete data.unexcused_days_remaining_of_the_year;
      // data.year = currentYear;
      // data.employee_id = this.mData.employeeId;
      // if (type == "update") {
      //   if(this.mData.statusHaveDayOff === true){
      //     data.id = this.mData.dataForm.id;
      //     await EmployeeDayOffApi.update(data);
      //   }else if(this.mData.statusHaveDayOff === false){
      //     await EmployeeDayOffApi.create(data);
      //   }
      // }
      // this.fn_initData();
    },

    fn_formatDate(val) {
      return MethodService.formatDate(val, 'date');
    },

    //event table
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },

    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },

    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_detailDayOffReq(this.year);
    },
  },

    //run after render view
    created() {
      if (
        this.$router.currentRoute.name ==
        "Admin-" + this.mData.moduleName + "-create"
      ) {
        this.mData.viewMode = "create";
      }
      if (
        this.$router.currentRoute.name ==
        "Admin-" + this.mData.moduleName + "-update"
      ) {
        this.mData.viewMode = "update";
      }
      if (
        this.$router.currentRoute.name ==
        "Admin-" + this.mData.moduleName + "-detail"
      ) {
        this.mData.viewMode = "detail";
      }
      if (this.$router.currentRoute.params.id) {
        this.mData.employeeId = this.$router.currentRoute.params.id;
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
      this.fn_initData();
      EventBus.$off('click_NghiPhep');
      EventBus.$on('click_NghiPhep',(data)=>{
        if(data.type_button == "create"){
          this.fn_submit("create");
        }else if(data.type_button == "update"){
          this.fn_submit("update");
        }
      });
      EventBus.$on('rowClick_NghiPhep',async ()=>{
        // this.fn_getDataById(this.$router.currentRoute.params.id);
        this.fn_initData();
      })
    },
    mounted() {}
}
</script>
<style scoped>
  .title-card-header{
    font-size: 16px;
    font-weight: 500;
    color: #303133;
  }
  ::v-deep .el-form-item__content{
    margin-left: 0 !important;
  }
  ::v-deep .el-collapse{
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    -webkit-transition: .3s;
    transition: .3s;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  }
  ::v-deep .el-collapse-item__header{
    background-color: #FFF !important;
    border-radius: 4px;
  }
</style>
